export default "__VITE_ASSET__Cj0Pgbcs__"